import React from 'react';
import './ProgressBar.scss';

export type ProgressBarItem = {
    visible: boolean;
    order: number;
    text: string;
    active: boolean;
    disabled: boolean;
};

export type ProgressBarProps = {
    id: string;
    progressBarItems?: ProgressBarItem[];
};

const ProgressBar = React.memo(ProgressBarMemo, (prevProps, currentProps) => {
    return (
        JSON.stringify(prevProps.progressBarItems) ===
        JSON.stringify(currentProps.progressBarItems)
    );
});

function ProgressBarMemo({
    id,
    progressBarItems
}: ProgressBarProps): JSX.Element {
    const getLinkClasses = (disabled, active) => {
        let linkClasses = 'nav-link progress-bar-link';

        if (disabled === true) {
            linkClasses = linkClasses + ' next';
        } else {
            if (active === true) {
                linkClasses = linkClasses + ' active';
            } else {
                linkClasses = linkClasses + ' previous';
            }
        }

        return linkClasses;
    };

    const renderProgressBarItem = (index, text, active, disabled, order) => {
        let itemClasses = `nav-item order-${order} progress-bar-item`;

        if (active) {
            itemClasses = itemClasses + ' progress-bar-item-active';
        }

        if (disabled) {
            itemClasses = itemClasses + ' disabled';
        }

        const linkClasses = getLinkClasses(disabled, active);

        const item = (
            <li key={index} className={itemClasses}>
                <div className={linkClasses}>
                    <div className='progress-bar-number'>{index + 1}</div>
                    <div className='progress-bar-text'>{active && text}</div>
                </div>
            </li>
        );

        return item;
    };

    const renderProgressBar = () => {
        let panel = <></>;

        if (!progressBarItems || progressBarItems.length === 0) {
            return panel;
        }

        //as numbers are shown in the short navigation we need to make sure that they are ordered and sequential
        const visibleItems = progressBarItems.filter(
            (item) => item.visible === true
        );

        if (visibleItems.length === 0) {
            return panel;
        }

        const orderedVisibleItems = visibleItems.sort((item1, item2) => {
            return item1.order - item2.order;
        });

        panel = (
            <ul
                data-testid='progress-Bar'
                id={id}
                aria-label='progress-items'
                className='nav nav-pills amtrust-progress-bar'>
                {orderedVisibleItems.map((item, index) =>
                    renderProgressBarItem(
                        index,
                        item.text,
                        item.active,
                        item.disabled,
                        item.order
                    )
                )}
            </ul>
        );

        return panel;
    };

    return <>{renderProgressBar()}</>;
}

export default ProgressBar;
